module.exports = "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n    <meta charset=\"UTF-8\">\n    <title></title>\n</head>\n<body>\n\n</body>\n</html>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/breadcrumb/breadcrumb.template.html
// module id = ../../../../../src/app/layout/breadcrumb/breadcrumb.template.html
// module chunks = 3